module.exports = __webpack_public_path__ + "static/media/mc_lid_open.f0ac591a.svg";